import type React from 'react'

interface ServiceCardProps {
  id: string
  title: string
  description: string
  icon: React.ReactElement
  index: number
}

export function ServiceCard({ title, description, icon, index }: ServiceCardProps) {
  return (
    <li
      className="glass-card will-animate glass-card-hover rounded-2xl p-8 flex flex-col gap-4 list-none"
      style={{ '--i': index } as React.CSSProperties}
    >
      <span className="text-xs font-bold tracking-[0.2em] uppercase text-[color:var(--accent)] opacity-60 select-none">
        {String(index + 1).padStart(2, '0')}
      </span>
      <div className="text-[color:var(--accent)]">{icon}</div>
      <h3 className="text-xl font-bold text-white">{title}</h3>
      <p className="text-[color:var(--foreground-muted)] leading-relaxed text-sm">
        {description}
      </p>
    </li>
  )
}
